import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "results", "clearBtn"]
  static values = { url: String }

  connect() {
    this.debounceTimer = null
  }

  disconnect() {
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer)
    }
  }

  search() {
    const query = this.inputTarget.value.trim()

    // Show/hide clear button
    this.clearBtnTarget.style.display = query.length > 0 ? "inline-block" : "none"

    // Debounce the search
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer)
    }

    if (query.length < 2) {
      this.resultsTarget.style.display = "none"
      this.resultsTarget.innerHTML = ""
      return
    }

    this.debounceTimer = setTimeout(() => {
      this.performSearch(query)
    }, 300)
  }

  async performSearch(query) {
    try {
      const url = `${this.urlValue}?q=${encodeURIComponent(query)}`
      const response = await fetch(url, {
        headers: {
          "Accept": "text/html",
          "X-Requested-With": "XMLHttpRequest"
        }
      })

      if (response.ok) {
        const html = await response.text()
        this.resultsTarget.innerHTML = html
        this.resultsTarget.style.display = html.trim().length > 0 ? "block" : "none"
      }
    } catch (error) {
      console.error("Search error:", error)
    }
  }

  clear() {
    this.inputTarget.value = ""
    this.resultsTarget.style.display = "none"
    this.resultsTarget.innerHTML = ""
    this.clearBtnTarget.style.display = "none"
    this.inputTarget.focus()
  }
}
